<template>
  <div>
    <div class="container-fluid pb-1">
      <!-- top -->
      <div class="px-3 py-5">
        <h4 class="h3 text-muted font-weight-bold">Meta-data Management</h4>
        <span> Select the type of meta-data you wish to manage </span>
        <div class="row align-items-center mt-4">
          <div class="col-md-4">
            <label class="h6 font-weight-bold d-block">Meta-Data Type</label>
            <div class="form-group mb-0">
              <b-form-select
                v-model="MetaDataType"
                class="form-control"
                :options="MetaDataTypeOptions"
              ></b-form-select>
            </div>
          </div>
          <div class="col-md-4">
            <label class="h6 font-weight-bold d-block">Select Indicator</label>
            <div class="form-group mb-0">
              <b-form-select
                v-model="Datasource"
                class="form-control"
                :options="DatasourceOptions"
              ></b-form-select>
            </div>
          </div>
          <div class="col-md-4">
            <label class="h6 font-weight-bold d-block">Classification type</label>
            <div class="form-group mb-0">
              <b-form-select
                v-model="Classification"
                class="form-control"
                :options="ClassificationTypeOptions"
              ></b-form-select>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-sm-4 my-4 row mx-1" style="top: 75px">
        <div class="col-lg-12">
          <div class="border p-4">
            <h4 class="font-bold">Available Meta-data</h4>
            <div style="display: grid; grid-template-columns: auto auto auto; gap: 40px">
              <div
                style="
                  box-shadow: 0px 3px 6px #00000029;
                  border-radius: 4px;
                  height: 291px;
                  width: 555px;
                "
                class="border d-flex flex-column p-4 mt-4"
              >
                <h5 class="text-primary">Total Fertility Rate</h5>
                <small class="text-muted mt-3">RMNCH - Program Area</small>
                <strong style="font-size: 14px">NDHPPS, NHS, UNICEF</strong>
                <span style="height: 100px" class="mt-3 truncate-text"
                  >This gives a short description of the meta data, and this place will talk about
                  national information of the Datasources</span
                >
                <a class="d-flex align-items-center font-bold"
                  >View Details <i class="el-icon-arrow-right pl-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MetaDataManagement",
  data() {
    return {
      MetaDataType: null,
      Datasource: null,
      Classification: null,
    };
  },
  computed: {
    MetaDataTypeOptions() {
      return [
        { value: "datasource", text: "Datasource" },
        // Add more file types as needed
      ];
    },
    DatasourceOptions() {
      return [
        { value: 1, text: "MICS -Multiple Indicator Cluster Survey" },
        // Add more file types as needed
      ];
    },
    ClassificationTypeOptions() {
      return [
        { value: "survey", text: "Survey" },
        // Add more file types as needed
      ];
    },
  },
};
</script>

<style scoped>
.truncate-text {
  max-height: 100px; /* Set your maximum height here */
  max-width: 555px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 0; /* Number of lines to show before truncating */
  -webkit-box-orient: vertical;
}
</style>
